import { Chip } from '@mui/material';
import IconButtonOverflowH from "components/Buttons/IconButtonOverflowV";
import { TopicSuggestionDto } from "models/ApiModels";
import * as React from "react";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    topics: TopicSuggestionDto[];
    onTopicClick?: (topicId: string) => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const TopicsLine: React.FC<IProps> = (props) => {

    const { topics, onTopicClick } = props;

    return (
        <>
            {
                topics.map((v, index) => {
                    return (index < 3)
                        ? (
                            <React.Fragment key={v.key}>
                                <Chip
                                    tabIndex={-1}
                                    size="small"
                                    label={v.label}
                                    onClick={() => { onTopicClick && onTopicClick(v.key); }}
                                />
                                &nbsp;
                            </React.Fragment>
                        )
                        : null;
                })
            }

            {
                topics.length > 3
                    ? <Chip
                        key="TopicOverflow"
                        tabIndex={-1}
                        size="small"
                        label={<IconButtonOverflowH />}
                    />
                    : null
            }
        </>
    );
};
